import { App_Url_New } from "@/src_new/shared/common/static";
import { whiteLabelResources } from "./resources";
import { WhiteLabelContactButton } from "./types";

const contactButtons: WhiteLabelContactButton[] = [
  {
    title: "InsuranceHub bot",
    subtitle: "Message us",
  },
  {
    title: "WhatsApp",
    subtitle: "Chat with us",
    href: "https://wa.me/6005089000",
  },
];

export const whiteLabelContent = {
  app: {
    title: "Default Theme",
    faviconPath: whiteLabelResources.App_Url.public.BrandLogo,
  },
  brand: {
    logo: {
      src: whiteLabelResources.App_Url.public.BrandLogo,
      alt: "InsuranceHub logo",
      width: 300,
      height: 60,
    },
    fallbackText: "Default Theme",
  },
  company: {
    poweredBy: "Nexsys",
    legalEntity: "InsuranceHub Insurance Brokers L.L.C",
  },

  contact: {
    phoneLabel: "000 000 000",
    phoneValue: "0000000000",
    whatsappNumber: "0000000000",
    generalEmail: "",
    customerServiceEmail: "",
    chatbotAlertMessage: "Chatbot feature coming soon!",
  },
  homepage: {
    hero: {
      eyebrow: "Getting insurance can be confusing. InsuranceHub makes it simple",
      titleLines: ["Click. Pick.", "Insure."],
      ctaLabel: "GET QUOTE",
      featuredProductPath: App_Url_New.secured.frontlinks.opportunitiesAdd,
    },
    stats: {
      dealsTitle: "Exciting deals",
      dealsSubtitle: "Limited period only",
      policyholdersCount: "25K",
      policyholdersLabel: "Happy policyholders",
    },
    whyChooseUs: {
      heading: "Why go with InsuranceHub?",
      imageAlt: "Why InsuranceHub",
      features: [
        {
          title: "Instant Coverage",
          description: "Get covered, anytime, anywhere with our simple digital platform.",
        },
        {
          title: "Top insurers",
          description: "We help you get the right product from trusted providers.",
        },
        {
          title: "Backed by the best",
          description: "We’re backed by Nexsys, a leading bank in the UAE for over 4 decades.",
        },
        {
          title: "Expert assistance",
          description: "Claim the stress-free way with friendly specialists by your side.",
        },
      ],
    },
    offers: {
      heading: "Tap into limited time offers",
      items: [
        {
          title: "Save AED 750*",
          description:
            "Get a AED 750 refund on your first claim on policies issued by RAKINSURANCE.",
          terms: "* Comprehensive policies only for individuals",
        },
        {
          title: "Enjoy ZERO interest",
          description:
            "Easy Payment Plan on Nexsys Credit Card - 3, 6, 9 and 12 months tenor available.",
          terms: "Terms and conditions",
        },
        {
          title: "Free car wash",
          description:
            "And discount on car services with AG Cars offered by Sukoon Insurance Company.",
          terms: "Terms and conditions",
        },
      ],
    },
    products: {
      eyebrowPrefix: "Click. Pick.",
      eyebrowHighlight: "Insure.",
      heading: "Top protection in your hands",
      ctaLabel: "GET QUOTE",
    },
    mascot: {
      heading: "Meet P-Go",
      description: "Your go-to buddy for quick and fuss-free insurance solutions",
      imageAlt: "P-Go mascot",
      pillars: [
        {
          title: "Buy",
          description: "Digitally or guided by friendly experts.",
        },
        {
          title: "Claim",
          description: "We'll help, so you can have peace-of-mind.",
        },
        {
          title: "Keep track",
          description: "With all your policy documents, secure and in one place.",
        },
      ],
    },
    contactSection: {
      heading: "Got question?",
      buttons: contactButtons,
    },
  },
  auth: {
    heroTitle: "Manage Your Insurance Business Smarter",
    heroDescription:
      "Your complete CRM solution for tracking quotes, policies, and client relationships across all insurance categories.",
    features: [
      {
        title: "Multi-Insurer Management",
        description: "RAK, GIG, Salama, Sukoon, Oriental",
        dotClassName: "bg-theme-success-strong",
      },
      {
        title: "Complete Pipeline Tracking",
        description: "From quote to policy issuance",
        dotClassName: "bg-theme-success-strong",
      },
    ],
    copyrightText: "© 2026 InsuranceHub Insurance Portal. All rights reserved.",
    brandSubtitle: "Nexsys",
    welcomeTitle: "Welcome Back",
    welcomeDescription: "Enter your credentials to access your dashboard",
    submitLabel: "Sign in",
    rememberLabel: "Remember me for 30 days",
    helpText: "Need access?",
    helpCtaLabel: "Contact your administrator",
    legalPrefix: "By signing in, you agree to our",
    legalLinks: [
      { label: "Terms of Service", href: "#" },
      { label: "Privacy Policy", href: "#" },
    ],
    otpFooterPrefix: "New to InsuranceHub?",
    otpFooterCta: "Get a quote",
    otpFooterSuffix: "to get started.",
  },
  journeys: {
    marketingConsentLabel:
      "I agree to receive updates from InsuranceHub about quotes, products and promotional offers through marketing channels including SMS and Email.",
    quoteMascotAlt: "Meet P-Go Cat",
    policyPending: {
      paymentPlanHeading: "EASY PAYMENT PLAN ON Nexsys",
      paymentPlanSubtext: "Credit Card (3, 6, 9 & 12 months)",
      specialistFollowUp: "One of our InsuranceHub specialists will contact you shortly.",
    },
    travel: {
      howItWorksHeading: "It’s easy to InsuranceHub",
      whyBetterHeading: "See what makes InsuranceHub better",
      paymentPlanText: "on Nexsys Credit Card",
      trustedByManyText: "Thousands insured with InsuranceHub",
    },
  },
  footer: {
    copyrightOwner: "InsuranceHub",
    copyrightLink: "#",
    regulatoryText:
      "InsuranceHub Insurance Brokers L.L.C is licensed by The Central Bank of the UAE (CBUAE), Registration number 288. Holder of Health Insurance Intermediary Permit (HIIP) no. BRK-00193 issued by the Dubai Health Authority (DHA). Registered Address: Empire Heights R Plot Number 75 Property Number R01 R02 R03, Ground Floor, Business Bay, Dubai, UAE. PO Box 1531",
  },
} as const;
